import Checkbox from './checkBox'
import Group from './Group'

Checkbox.Group = Group

export default Checkbox